export default "__VITE_ASSET__3c0fb50c__"